export default __webpack_public_path__ + "static/media/VeevaEngageForegroundPermissions.f5bb7893.mp4";